import React, { useEffect, useState } from "react";
import { useSelector, useStore } from "react-redux";
import { getFront, selectPlayers } from "../state/reducers/NewFrontReducer";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  GetSingleTeam,
  SelectTeam,
  SelectStatus,
} from "../state/reducers/TeamReducer";
import SingleTeamHeader from "../components/SingleTeam/SingleTeamHeader";
import { MyContainer } from "../globals/Globals";
import { Box, Tabs, Tab } from "@mui/material";
import RanksTable from "../components/Tables/RanksTable";
import MatchesTable from "../components/Tables/MatchesTable";
import { PageContainer } from "../globals/styles";
import { useParams } from "react-router-dom";
import { RegisterPageView } from "../globals/Analytics";
import UpcomingGamesTable from "../components/SingleTeam/UpcomingGamesTable";
import Loading from "../components/Loading";
import MyTransition from "../components/Theming/MyTransition";
import SingleTeamPlayers from "../components/SingleTeam/SingleTeamPlayers";

const SingleTeam = () => {
  let { name } = useParams<{ name: string }>();
  const [animate, setAnimate] = useState(false);
  const dispatch = useAppDispatch();

  const isloading = useAppSelector(SelectStatus);
  useEffect(() => {
    dispatch(GetSingleTeam(name));
    RegisterPageView({ path: `/team/${name}` });
  }, [name]);

  const [selectedTab, setSelectedTab] = useState(0);
  const theTeam = useAppSelector(SelectTeam);
  const singleteam = theTeam;
  const thematch = theTeam["lastmatch"];

  if (isloading === "loading") {
    return <Loading />;
  }

  setTimeout(() => {
    setAnimate(true);
  }, 100);

  return (
    <div>
      <SingleTeamHeader
        team={singleteam.team}
        upcoming={singleteam.upcoming}
        lastmatch={singleteam.lastmatch}
      />
      <MyTransition location="/singleteam" inProp={animate}>
        <PageContainer>
          <MyContainer maxWidth="xl">
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                marginBottom: "1rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Tabs
                value={selectedTab}
                onChange={(e, v) => setSelectedTab(v)}
                variant="scrollable"
                style={{ marginBottom: "1rem" }}
              >
                <Tab label="Players" />
                <Tab label="Games" />
                <Tab label="Upcoming" />
              </Tabs>
            </Box>
            {selectedTab == 0 ? (
              <div>
                <RanksTable ranks={singleteam.team.ranks} />
                {/* <PlayerCardsContainer players={singleteam.players} positionname="any"/> */}
                <SingleTeamPlayers
                  players={singleteam.players}
                  teamname={singleteam.team.name}
                />
              </div>
            ) : null}
            {selectedTab === 1 ? (
              <div>
                <MatchesTable
                  matches={singleteam.matches}
                  aboutTeam={singleteam.team.name}
                />
              </div>
            ) : null}
            {selectedTab === 2 ? (
              <div>
                <UpcomingGamesTable
                  matches={singleteam.upcoming}
                  teamname={singleteam.team.name}
                />
              </div>
            ) : null}
          </MyContainer>
        </PageContainer>
      </MyTransition>
    </div>
  );
};

export default SingleTeam;
